var exports = {
  "qr": "footer__8A4fhA",
  "kL": "container__kVJA3u",
  "mY": "topRow__EL-6UQ",
  "IA": "newsletter__vt4udc",
  "YB": "columns__VahZhC",
};

module.exports = exports;
